/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Box, IconButton, styled, MenuItem } from "@mui/material";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import {
  Link,
  Typography,
  Button,
  TextField,
  Select,
  InputLabel,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import HowToRegIcon from '@mui/icons-material/HowToReg';

export const StyledHeadingContainer = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const StyledBreadCrumbContainer = styled("div")({
  height: "20px",
  backgroundColor: "#f5f5f8",
  padding: "10px 0px 10px 20px",
  borderColor: "#e0e0e0",
  borderWidth: "0px 0px 1px 0px",
  borderStyle: "solid",
});

export const StyledLink = styled(Link)(({ color }) => ({
  textDecoration: "none",
  color: color,
  fontSize: "13px",
  fontWeight: "400",
}));

export const StyledTitleContainer = styled("div")({
  padding: "20px 0px 10px 0px",
});

export const StyledTitle = styled(Typography)({
  fontSize: "24px",
  fontWeight: "700",
  lineHeight: "40px",
});

export const StyledCreateButton = styled(Button)({
  textTransform: "none",
  fontWeight: "600",
  boxShadow: "none",
});

export const StyledCancelButton = styled(Button)({
  "&:hover": {
    textTransform: "none",
    fontWeight: "600",
    boxShadow: "none",
    border: "2px solid #001b59",
    borderRadius: "8px",
    color: "#001b59",
  },
  textTransform: "none",
  fontWeight: "600",
  boxShadow: "none",
  border: "2px solid #395bbd",
  borderRadius: "8px",
  color: "#395bbd",
});

export const StyledAddButton = styled(Button)({
  "&.Mui-disabled": {
    backgroundColor: "#e0e0e0",
  },
  "&:hover": {
    textTransform: "none",
    fontWeight: "600",
    boxShadow: "none",
    backgroundColor: "#001b59",
    borderRadius: "8px",
    padding: "0px 30px",
  },
  textTransform: "none",
  fontWeight: "600",
  boxShadow: "none",
  backgroundColor: "#395bbd",
  borderRadius: "8px",
  padding: "0px 30px",
});

export const StyledButtonContainer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  padding: "15px 20px 5px 20px",
});

export const StyledCreateTitle = styled(Typography)({
  fontSize: "34px",
  fontWeight: "700",
  textWrap: "nowrap",
  marginTop: "10px",
  textAlign: "center",
});

export const StyledFormContainer = styled("div")({
  marginTop: "10%",
});

export const StyledFormFieldText = styled(Typography)({
  fontWeight: "600 !important",
  fontSize: "15px !important",
  marginBottom: "5px",
  color: "rgba(81, 81, 82, 1);",
});

export const StyledTypography = styled(Typography)({

})

export const StyledTextField = styled(TextField)({
  "&:hover": {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "2px solid #395bbd !important",
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px",
    borderRadius: "8px",
  },
});

export const StyledDatePicker = styled(DatePicker)({
  width: "100%",
  ".MuiInputBase-root": {
    height: "2.6rem",
    backgroundColor: "white",
    fontSize: "1rem",
  },
  "& input::placeholder": {
    color: "black",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px",
    borderRadius: "8px",
  },
  "&:hover": {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "2px solid #395bbd !important",
    },
  },
});

export const StyledHelperText = styled("span")({
  color: "#d32f2f",
  fontSize: "0.75rem",
  padding: "12px !important",
  letterSpacing: "0.3px",
  marginBottom: "10px",
});

export const StyledPhoneField = styled(PhoneInput)(({ borderColor }) => ({
  "&:hover": {
    "& .react-international-phone-input": {
      border: "2px solid #395bbd !important",
    },
  },
  "&:focus-within": {
    "& .react-international-phone-input": {
      border: "2px solid #1976d2 !important",
    },
  },
  "& .react-international-phone-input": {
    width: "100% !important",
    borderRadius: "0px 8px 8px 0px !important",
    height: "40px !important",
    borderColor: borderColor,
  },
  "& .react-international-phone-country-selector-button": {
    height: "40px !important",
    borderRadius: "8px 0px 0px 8px !important",
    borderColor: borderColor,
  },
}));

export const RestaurantAdminContainer = styled("div")({
  height: "100%",
  width: "100%",
  overflowY: "scroll",
  overflowX: "hidden",
  paddingRight: "30px",
});

export const StyledUpdateButton = styled(Button)({
  "&.Mui-disabled": {
    backgroundColor: "#001b59",
  },
  "&:hover": {
    textTransform: "none",
    fontWeight: "600",
    boxShadow: "none",
    backgroundColor: "#001b59",
    borderRadius: "8px",
  },
  textTransform: "none",
  fontWeight: "600",
  boxShadow: "none",
  backgroundColor: "#395bbd",
  borderRadius: "8px",
});

export const StyledSelect = styled(Select)({
  width: "100%",
  "&.MuiInputBase-root": {
    borderRadius: "10px",
    height: "2.6rem",
  },
  "&:hover": {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "2px solid #395bbd !important",
    },
  },
});

export const StyledInputLabel = styled(InputLabel)({
  fontSize: "14px",
});

export const StyledSearchIconButton = styled(IconButton)({
  "&.Mui-disabled": {
    backgroundColor: '#e0e0e0',
  },
  '&:hover':{
    backgroundColor: '#e0e0e0',
  },
  backgroundColor: '#e0e0e0',
})

export const StyledCrossButton = styled(IconButton)({
  "&.Mui-disabled": {
    backgroundColor: '#e0e0e0',
  },
  '&:hover':{
    backgroundColor: '#e0e0e0',
  },
  backgroundColor: '#e0e0e0',
})

export const StyledHeaderMenuItem = styled(MenuItem)({
  fontSize: "0.875rem",
  cursor: 'default',
  pointerEvents: 'none'
})

export const StyledHowToRegIcon = styled(HowToRegIcon)({
  color: 'green'
})
